import { TextField } from "@mui/material";
import type { PropsWithChildren, ReactNode, SelectHTMLAttributes } from "react";

export type SelectProps = PropsWithChildren<
  Pick<
    SelectHTMLAttributes<HTMLInputElement>,
    "id" | "name" | "value" | "disabled" | "onChange" | "onBlur" | "onFocus"
  > & {
    label?: ReactNode;
    placeholder?: string;
    error?: boolean;
    helperText?: ReactNode;
    ref?: React.Ref<HTMLInputElement>;
    open?: boolean;
    onOpen?: () => void;
  }
>;

export function Select({ children, open, onOpen, ...props }: SelectProps) {
  return (
    <TextField
      {...props}
      hiddenLabel={!props.label}
      fullWidth
      select
      slotProps={{
        select: {
          open,
          onOpen,
        },
      }}
    >
      {children}
    </TextField>
  );
}
